import { API_CONFIG } from '../config/api';

export const getProfilePictureUrl = (filePath?: string | null) => {
  if (!filePath) return undefined;
  const normalizedPath = filePath.replace(/\\/g, '/').replace(/^\/+/, '');
  const base = API_CONFIG.BASE_URL.replace(/\/+$/, '');
  return `${base}/${normalizedPath}`;
};
